import getParamsFromString from "./getParamsFromString";
import getValueFromParamsList from "./getValueFromParamsList";
import _ from 'lodash'

const getNextScreen = (destination, screenName, globalValues, listName, row) => {
    const {application, queryParam} = globalValues;
    let nextScreen;
    let url;
    let idType;
    if (listName && !_.isEmpty(row)) {
        nextScreen = getValueFromParamsList({value: destination}, screenName, listName, globalValues, row);
        if (row._entity && row.id) {
            idType = typeof row.id;
            url = `${nextScreen}`
        } else {
            url = nextScreen
        }
    } else {
        let params = getParamsFromString(destination, globalValues, screenName);
        url = params;
        nextScreen = params;
    }
    let isDoubleSlash = url ? url.indexOf('//') === 0 : false;
    let nextApplication = isDoubleSlash ? url.split('/')[2] : false;
    let isNoSlash = url ? url.indexOf('/') !== 0 : false;
    url = nextApplication ?
        url.substring(1) :
        `/${application}${isNoSlash ? '/' : ''}${url}`;

    if(queryParam) {
        url = url + '/' + JSON.stringify(queryParam);
    }

    return {url, nextScreen: getNextScreenId(url, isDoubleSlash), idType}
};

export default getNextScreen;


export function getNextScreenId(url, isDoubleSlash) {
    if (url && url.indexOf('/') === 0) {
        return url.substring(1).split('/')[1] || '/'
    }
    if (url) {
        return url.indexOf('/') !== -1 ? url.split('/')[isDoubleSlash ? 3 : 1] : url;
    }

    return ''
}